import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import { OrderingListViewModel, UpdateOrderingListCommand, CreateOrderingListCommand, UserHierarchyViewModel, GetUserHierarchyListWithoutOrderingListRequest } from "Api/CoreApi";
import store from "Store/index"
import { mixins } from 'vue-class-component';
import UserMixin from 'Mixins/UserMixin';
import BaseComponent from 'Components/Base/ABaseComponent';
import ApiFactory from 'Api/ApiFactory';
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';
import Multiselect from 'vue-multiselect';



export interface SelectModel{
    id: string;
    name: string;
    obj: UserHierarchyViewModel;
    $isDisabled: boolean;    
}

@Component({
    template: "#ordering-list-overview-template",
    components: {
        Multiselect
    }
})
export default class OrderingListOverviewComponent extends mixins(BaseComponent,OrderingListUserMixin) {
    
    public newName: string = ""; 
    public showNew: boolean = false; 
    public budget: number;

    @Prop()
    public userIdentity: string;
    
    //users without an attached list
    availableNewOrderingListUsers: { [key: string]: UserHierarchyViewModel[]; } = null;
    selectedNewOrderingListUser: SelectModel = null;
    
    async created() {
        store.state.orderingList.userIdentity = this.userIdentity;
        this.setLoading();
        await store.dispatch.orderingList.loadOrderingLists(false);
        this.setLoaded();
    }
    
    
    //selector
    get options(): any{
        if(this.availableNewOrderingListUsers){
            {
                const list = new Array<SelectModel>();
                for(let key in this.availableNewOrderingListUsers)
                {
                    const value = this.availableNewOrderingListUsers[key];
                    
                    const parentObj = value[0].parent;
                    
                    list.push(<SelectModel>{
                        id : key,
                        $isDisabled: true,
                        name: key,
                        obj : parentObj
                    });
                    
                    
                    for(let child of value)
                    {
                        var obj: SelectModel = {
                            id : child.customerNumber,
                            $isDisabled : false,
                            name : child.customerNumber,
                            obj : child
                        }
                        list.push(obj);
                    }
                }
                return list;
            }
        }
        return new Array<SelectModel>();
    }

    resolveTrClass(index: number){
        // console.debug(index);
        return (index %  2 == 0) ? 'tr-even' : 'tr-odd';
    }
    
    customLabel(model: SelectModel): string{
        if(model.$isDisabled){
            return `${model.obj.level} | ${this.customLabelForUser(model.obj)}`;
        }
        else{
            return `${model.obj.level} | ${this.customLabelForUser(model.obj)}`;
        }
    }
    
    
    customLabelForUser(obj: UserHierarchyViewModel): string {
        return `${obj.customerNumber.replace('-at-SHOP1','')} (${obj.companyName} : ${obj.customerAddress})`;
    }
    
    get hierarchyLists():  OrderingListOverviewViewModel[]{
        if(this.lists)
        {
            const newList = new Array<OrderingListOverviewViewModel>();
            
            if(this.isEmployee || this.isCCustomer)
            {
                let childs = new Array<OrderingListViewModel>();
                {
                    let obj =   <OrderingListOverviewViewModel> {
                        id: 'c-level',
                        detail: {},
                        childs : childs
                    }
                    newList.push(obj);
                }
                
                //if employee - only iterate over C lists
                for(let list of this.lists)
                {
                    childs.push(list);
                }
                return newList;
                
            }else{
                //if customer (hierarchy debitor)
                for(let list of this.lists)
                {
                    if(list.hierarchyType == "ABC" || list.level == 3) continue;
                    
                    let childs = new Array<OrderingListViewModel>();
                    let obj =   <OrderingListOverviewViewModel> {
                        id: list.id,
                        detail: list,
                        childs : childs
                    }
                    newList.push(obj);
                    
                    for(let listNext of this.lists)
                    {
                        if((listNext.hierarchyType == "ABC" || listNext.level == 3) && listNext.parentUserIsolationKey == list.userIsolationKey)
                        {
                            childs.push(listNext);
                        }
                    }
                }
                
                return newList;
            }
        }
        return <any>{};
    }    
    
    
    get lists(): OrderingListViewModel[] {
        const changes = store.state.orderingList.detectChanges;
        return store.getters.orderingList.orderingLists;
    }
    
    get showlist(){
        return this.lists? this.lists.length > 0 : false; 
    }
    
    
    async update(id: string, name: string, budget: number) {
        store.dispatch.orderingList.updateOrderingList(new UpdateOrderingListCommand({
            id: id,
            name: name,
            budget: budget
        }));
    }
    
    
    async createNew() {
        store.dispatch.orderingList.createOrderingList(new CreateOrderingListCommand({
            name: this.newName,
            userIdentity: this.selectedNewOrderingListUser.id
            
        }));
        //Reset variables 
        this.showNew = false;
        this.newName = ""; 
    }
    
    async toggleShowNew(){  
        if(!this.showNew)   {
            this.showNew = true;
            
            const client = await ApiFactory.getOrderingListUserHierarchyClient();
            const response = await client.getUserHierarchyListWithoutOrderingList(new GetUserHierarchyListWithoutOrderingListRequest());
            this.availableNewOrderingListUsers = response.list;
        }  
        else{
            this.showNew = false;
        }
        
    }
    
    
}

Vue.component('ordering-list-overview', OrderingListOverviewComponent);


export interface OrderingListOverviewViewModel{
    id: string;
    detail: OrderingListViewModel,
    childs: OrderingListViewModel[]
}